<mat-icon [color]="color"
          class="ui-card-info-icon">{{ icon }}</mat-icon>

<div class="ui-card-info-content">
  {{ message }}
  <ng-content></ng-content>
</div>
